import type { AuthContextProps } from "react-oidc-context";

const RENEW_LOCK_NAME = "oidc-refresh";

export async function signinSilentWithLock(oidc: AuthContextProps) {
    if (!("locks" in navigator) || navigator.locks == null) {
        return oidc.signinSilent();
    }

    // Keycloak refresh tokens are single-use, so renewals must be serialized
    // across tabs sharing the same OIDC storage.
    return navigator.locks.request(RENEW_LOCK_NAME, () => oidc.signinSilent());
}
